export default "__VITE_ASSET__Cyn_VIb9__"